// extracted by mini-css-extract-plugin
export var text = "_4f-0";